import { Component, EventEmitter, Input, Output } from 'ng-metadata/core';

import './header.scss';


/**
 * @ngdoc directive
 * @name mwContentDocumentHeader
 * @module mw.components.contentDocuments
 *
 * @description
 *
 * @usage
 * <hljs hljs-language="html">
 *     <mw-content-document-header ng-if="!$ctrl.$transclude.isSlotFilled('mwContentDocumentHeader')">
 *         <mw-content-document-source-avatar ng-if="$ctrl.isAvatarVisible"></mw-content-document-source-avatar>
 *         <mw-content-document-media-type-icon></mw-content-document-media-type-icon>
 *         <mw-content-document-source-name></mw-content-document-source-name>
 *         <mw-content-document-authors>
 *              <mw-content-document-author
 *              ng-repeat="author in ::$ctrl.document.authors track by $index"
 *              text="::author.name"
 *              url="::$ctrl.isIcmEnabled && author.icmUrl ? author.icmUrl : author.url">
 *              </mw-content-document-author>
 *         </mw-content-document-authors>
 *         <mw-content-document-source-country country-code="::$ctrl.document.sourceCountryCode">
 *         </mw-content-document-source-country>
 *         <mw-content-document-timestamp date="::$ctrl.document.date"></mw-content-document-timestamp>
 *         <mw-content-document-actions>
 *         </mw-content-document-actions>
 *     </mw-content-document-header>
 * </hljs>
 */
@Component({
    selector: 'mw-content-document-header',
    template: `
        <div class="mw-content-document-header" layout="row">
            <ng-transclude class="mw-content-document-header__source-avatar" ng-transclude-slot="mwContentDocumentSourceAvatar"></ng-transclude>
            <!-- <ng-transclude ng-transclude-slot="mwContentDocumentMediaTypeIcon"></ng-transclude> -->
            <div class="mw-content-document-header__detail" flex="100" layout="column" layout-align="space-between">
                <div class="mw-content-document-header__detail-first-row">
                    <ng-transclude ng-transclude-slot="mwContentDocumentSourceName"></ng-transclude>
                    <ng-transclude ng-transclude-slot="mwContentDocumentAuthors"></ng-transclude>
                </div>
                <div class="mw-content-document-header__detail-second-row">
                    <ng-transclude ng-transclude-slot="mwContentDocumentSourceCountry"></ng-transclude>
                    <ng-transclude ng-transclude-slot="mwContentDocumentTimestamp"></ng-transclude>
                </div>
            </div>
            <ng-transclude class="mw-content-document-header__actions" flex="noshrink" ng-transclude-slot="mwContentDocumentActions"><div></div></ng-transclude>
        </div>
    `,
    legacy: {
        transclude: {
            'mwContentDocumentSourceAvatar': '?mwContentDocumentSourceAvatar',
            'mwContentDocumentMediaTypeIcon': '?mwContentDocumentMediaTypeIcon',
            'mwContentDocumentSourceName': '?mwContentDocumentSourceName',
            'mwContentDocumentAuthors': '?mwContentDocumentAuthors',
            'mwContentDocumentSourceCountry': '?mwContentDocumentSourceCountry',
            'mwContentDocumentTimestamp': '?mwContentDocumentTimestamp',
            'mwContentDocumentActions': '?mwContentDocumentActions'
        }
    }
})
export class HeaderComponent {

    constructor() {}

}



// WEBPACK FOOTER //
// ./src/lib/components/content-documents/media-document/header/header.component.ts